/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import createPersistedState from 'use-persisted-state';
const useSiteLanguageState = createPersistedState('bottlebooks_lang');

export default function useSiteLanguage() {
  const preferredLang =
    typeof window !== 'undefined' ? window.navigator.languages?.[0] : 'en';
  // We only want to support the languages that are valid for this event.
  const resolvedPreferredLanguage = ['en', 'fr'].includes(preferredLang)
    ? preferredLang
    : 'en';
  const [{ lang }, _setLang] = useSiteLanguageState({
    lang: resolvedPreferredLanguage,
  });
  return {
    lang,
    setLang: ({ lang = 'en' }) => {
      _setLang({ lang });
    },
  };
}
